export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";